/*
 * @Description:
 * @Author: xiaoyao
 * @since: 2018-12-28 12:09:05
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-28 14:46:56
 */
import {
    official_get
} from '@/api/account/myOrgs.js'

const orgSetting = {
    namespaced: true,
    state: {
        curOrgSetting: null,
        quotationPayStore: null
    },

    mutations: {
        curOrgSetting: (state, data) => {
            state.curOrgSetting = data
            if (!data) {
                localStorage.removeItem("curOrgSetting");
            } else {
                console.log("curOrgSetting.set", JSON.stringify(data))
                localStorage.setItem("curOrgSetting", JSON.stringify(data));
            }

        },
        quotationPayStore: (state, data) => {
            state.quotationPayStore = data
            if (!data) {
                localStorage.removeItem("quotationPayStore");
            } else {
                localStorage.setItem("quotationPayStore", JSON.stringify(data));
            }

        },

    },

    actions: {
        // 获取当前组织机构logo等个性化设置
        curOrgSetting({
            state,
            commit,
            dispatch
        }) {

            console.log("curOrgSetting.actions", "12345")
            let orgObj = JSON.parse(localStorage.getItem("pro__ORG")).value;
            console.log("curOrgSetting.actions", orgObj)
            return new Promise((resolve, reject) => {
                official_get({
                    page_size: 10,
                    page: 1,
                    organization: orgObj.id
                }).then(res => {
                    console.log("curOrgSetting.actions.res", res)
                    if (res.data.length == 0) {

                        commit('curOrgSetting', null)
                    } else {
                        commit('curOrgSetting', res.data[0])
                        resolve(res.data[0])
                    }
                }).catch(error => {
                    commit('curOrgSetting', null)
                    reject(error)
                })
            })
        },


        quotationPayStore({
            commit,
        }, data) {
            return new Promise((resolve, reject) => {
                commit('quotationPayStore', data)
            })
        },
    },

    getters: {
        curOrgSetting: state => {
            if (!state.curOrgSetting) {
                state.curOrgSetting = !localStorage.getItem("curOrgSetting") ? {
                    "order_abbreviated": "测试",
                    "watermark": "测试",
                    "menu_logo_url": "",
                    "address": "公司地址",
                    "telephone": "公司联系方式",
                    "website": "官网地址",
                    "logo_url": "",
                    "seal_url": "",
                    "payment_code_url": "/static/img/fkm.png",
                    "isDeafalut": 0
                } : JSON.parse(localStorage.getItem("curOrgSetting"))
            }
            return state.curOrgSetting
        },

        quotationPayStore: state => {
            if (!state.quotationPayStore) {
                state.quotationPayStore = !localStorage.getItem("quotationPayStore") ? {
                    show: false,
                    data: {}
                } : JSON.parse(localStorage.getItem("quotationPayStore"))
            }
            return state.quotationPayStore
        },


    }
}

export default orgSetting



// WEBPACK FOOTER //
// ./src/store/modules/orgSetting.js